export class CompanyReservationCode {
    codeHolderId: string;
    codeHolderName: string;
    implementations: CompanyReservationCodeImplementation[];
    reservationId?: string;
    reservationName?: string;
    code: string;
}

export class CompanyReservationCodeImplementation {
    productId: string;
    productVariantId: string;
}

export const hasMatchingReservationImplementation = (codeHolder: CompanyReservationCode, productId: string, variantId: string): boolean => {
    return !!codeHolder?.reservationName && codeHolder?.implementations?.some(x => x.productId === productId && x.productVariantId === variantId);
};

export const hasMatchingCodeImplementation = (codeHolder: CompanyReservationCode, productId: string, variantId: string): boolean => {
    return !codeHolder?.reservationName && codeHolder?.implementations?.some(x => x.productId === productId && x.productVariantId === variantId);
};

export const hasMatchingImplementation = (codeHolder: CompanyReservationCode, productId: string, variantId: string): boolean => {
    return codeHolder?.implementations?.some(x => x.productId === productId && x.productVariantId === variantId);
};

export const getMatch = (codeHolders: CompanyReservationCode[], productId: string, variantId: string, codeHolderId: string): CompanyReservationCode => {
    return codeHolders?.find(x => x.codeHolderId === codeHolderId && hasMatchingImplementation(x, productId, variantId));
};
